import { Formik } from 'formik';
import Select from 'react-select';
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { formSelectDefault, getSelectErrorBorder } from '../../Components/constants/styles';
import { untagSchema } from './utils';
const UntagModal = ({ onCloseClick, show, formSubmit, loading }) => {
    const untagOptions = [
        { label: 'Added in Error by Assessment', value: 2 },
        { label: 'Agent Error', value: 3 },
        { label: 'Duplicate Need', value: 1 },
        { label: 'Member Does Not See as a Need', value: 4 }
    ];

    return (
        <>
            <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg">
                <ModalHeader className="bg-soft-primary">Reason for untag</ModalHeader>
                <ModalBody className="py-3 px-5">
                    <Formik
                        initialValues={{ reason: '' }}
                        validationSchema={untagSchema}
                        onSubmit={(values) => {
                            formSubmit(values?.reason?.value);
                        }}
                    >
                        {({ setFieldValue, values, errors, handleSubmit, touched, handleBlur }) => (
                            <>
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex mb-4">
                                        <Label className="col-form-label w-40">
                                            Reason
                                            <span className="text-danger">*</span>
                                        </Label>
                                        <Select
                                            name="reasonn"
                                            id="reason"
                                            value={values?.reason}
                                            components={{ IndicatorSeparator: () => null }}
                                            className="w-60"
                                            placeholder="Select"
                                            onChange={(e) => setFieldValue('reason', e)}
                                            styles={{
                                                ...formSelectDefault,
                                                ...getSelectErrorBorder(!!errors.reason && touched.reason)
                                            }}
                                            options={untagOptions}
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-end">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-md btn-primary waves-effect center waves-light me-3"
                                                onClick={handleSubmit}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Save'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-md btn-outline-primary"
                                                id="gapsCancel"
                                                onClick={onCloseClick}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Formik>
                </ModalBody>
            </Modal>
        </>
    );
};

export default UntagModal;
